export default "__VITE_ASSET__CgKm4xqB__"